import React from "react";
import { withRouter } from "react-router-dom";

import PaginationBar from "./PaginationBar";

import { Scopes } from "Services";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowDown } from "@fortawesome/pro-solid-svg-icons/faArrowDown";
import { faArrowUp } from "@fortawesome/pro-solid-svg-icons/faArrowUp";
import CardBody from "../Card/CardBody";
import Card from "../Card/Card";

Table.Thead = ({ children, className, ...rest }) => {
    return (
        <thead {...rest} className={className}>
        {children}
        </thead>
    );
};

Table.Tr = withRouter(({ children, onClick, className, to, history, location, match, staticContext, ...rest }) => {
    const handleClick = (e) => {
        const ignore = ['A', 'BUTTON', 'INPUT', 'SELECT', 'TEXTAREA'];
        if (ignore.includes(e.target.tagName)) {
            return true;
        }

        if (to) {
            history.push(to);
        }

        if (onClick) {
            onClick();
        }
    };

    return (
        <tr {...rest} className={`${className} ${to || onClick ? 'cursor-pointer' : ''}`} onClick={handleClick}>
            {children}
        </tr>
    );
});

Table.Th = ({ children, order, onChange, column, className, scope, ...rest }) => {
    if (scope && !Scopes.has(scope)) {
        return null;
    }

    return (
        <th
            { ...rest }
            className={ `px-2 py-3 bg-gray-50 text-left font-semibold whitespace-nowrap text-gray-900 top-0 ${onChange ? 'cursor-pointer' : ''} sticky ${ className }` }
            onClick={() => onChange ? onChange(column) : false}
        >
            <div className="flex items-center">
                { children }

                {column && order?.column === column && (
                    <FontAwesomeIcon icon={
                        order?.direction === 'asc' ? faArrowDown : faArrowUp
                    } className="ml-1"/>
                ) }
            </div>
        </th>
    );
};

Table.Tbody = ({ children, className, ...rest }) => {
    return (
        <tbody { ...rest } className={ `divide-y divide-gray-200 ${ className }` }>
        { children }
        </tbody>
    );
};

Table.Td = ({ children, className, scope, ...rest }) => {
    if (scope && !Scopes.has(scope)) {
        return null;
    }

    return (
        <td {...rest} className={`whitespace-nowrap px-2 py-2 text-sm text-gray-500 capitalize ${className}`}>
            {children}
        </td>
    );
};


Table.Tfoot = ({ children, className, ...rest }) => {
    return (
        <tfoot {...rest} className={`bg-gray-50 ${className}`}>
        {children}
        </tfoot>
    );
};

export default function Table({ children, containerClassName, innerContainerClassName, pagination, sticky = true }) {
    if (pagination?.total === 0) {
        return (
            <Card>
                <CardBody>
                    <p className="text-center text-sm leading-5">
                        There are currently no items to display.
                    </p>
                </CardBody>
            </Card>
        );
    }

    return (
        <div className={`bg-white shadow overflow-hidden text-sm leading-5 ${containerClassName}`}>
            <div className={`overflow-auto shadow ring-1 ring-black ring-opacity-5 ${innerContainerClassName} relative`}  style={sticky ? { maxHeight: `calc(100vh - ${pagination ? '202' : '132'}px)` } : {}}>
                <table className="min-w-full divide-y divide-gray-300 whitespace-nowrap">
                    {children}
                </table>
            </div>

            {pagination && (
                <PaginationBar {...pagination} />
            )}
        </div>
    );
}
